import type { ReactNode } from 'react'

interface PanelCardProps {
  title: string
  subtitle?: ReactNode
  action?: ReactNode
  className?: string
  children: ReactNode
}

/**
 * Shared chart/panel wrapper with a light header strip above the content,
 * instead of each panel floating its own <h3> directly in the padded body.
 * Inspired by .guides/PlantillaKPIs.png's per-panel gray header bar -- kept
 * in this app's own cream/espresso palette, not the template's blue.
 */
export default function PanelCard({ title, subtitle, action, className, children }: PanelCardProps) {
  return (
    <div className={`bg-cream-50 shadow rounded-lg border border-cream-200 overflow-hidden ${className || ''}`}>
      <div className="flex items-start justify-between gap-4 bg-cream-100 border-b border-cream-200 px-6 py-3">
        <div className="min-w-0">
          <h3 className="text-sm font-semibold text-espresso-800">{title}</h3>
          {subtitle && <p className="text-xs text-espresso-500 mt-0.5">{subtitle}</p>}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>
      <div className="p-6">{children}</div>
    </div>
  )
}
